import React from "react";
import { FaLinkedin } from "react-icons/fa";
import profile from "../images/profile.png";

function Card({ name, title }) {
  return (
    <div className="w-full pt-8">
      <div className="flex flex-col justify-center max-w-xs mx-auto bg-white shadow-xl rounded-xl p-5">
        <div className="">
          <img
            className="w-32 mx-auto shadow-xl rounded-full"
            src={profile}
            alt="Profile face"
          />
        </div>
        <div className="text-center mt-5">
          <p className="text-xl sm:text-2xl font-semibold text-gray-700">
            {name}
          </p>
          <p className="text-xs sm:text-base text-gray-600 pt-2 pb-4 px-5 w-auto inline-block border-t-2">
            {title}
          </p>
          <div className="flex align-center justify-center mt-4">
            <a
              className="text-xl m-1 p-1 text-gray-800 hover:bg-gray-800 rounded-full hover:text-white transition-colors duration-300"
              href="https://www.linkedin.com/in/mathilde-pinchon-a13618198"
            >
              <FaLinkedin />
              <span className="sr-only">LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
